import { render } from "./PasswordResetConfirm.vue?vue&type=template&id=295471ac&scoped=true"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=js"

import "./PasswordResetConfirm.vue?vue&type=style&index=0&id=295471ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295471ac"]])

export default __exports__